import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import "./Navbar.css";

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        function onResize() {
            if (window.innerWidth > 768) setOpen(false);
        }
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    const scrollToFeatures = () => {
        const el = document.getElementsByClassName("cards-container")[0];
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };

    const scrollToContact = () => {
        const el = document.getElementsByClassName("mobilex-section")[0];
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };

    const scrollToServices = () => {
        const el = document.getElementsByClassName("tabs-container")[0];
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };

    const scrollToBento = () => {
        const el = document.getElementsByClassName("bento-box-container")[0];
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };



    return (
        <header className="nav-wrap">
            <nav className="nav">
                <div className="brand">
                    <Link to="/" className="logo" onClick={() => setOpen(false)}>
                        <img className="logoo" src="/Assets/logo.png" alt="" />
                    </Link>
                </div>

                <button
                    className="menu-toggle"
                    aria-expanded={open}
                    aria-label={open ? "Close menu" : "Open menu"}
                    onClick={() => setOpen((s) => !s)}
                >
                    <span className={`hamburger ${open ? "open" : ""}`} />
                </button>

                <ul className={`nav-links ${open ? "open" : ""}`}>
                    <li>
                        <button type="button" className="nav-link-button" onClick={() => { setOpen(false); navigate('/'); }}>
                            Anasayfa
                        </button>
                    </li>
                    <li>
                        <button type="button" className="nav-link-button" onClick={() => { setOpen(false); scrollToBento(); }}>
                            Hakkimizda
                        </button>
                    </li>
                    <li>
                        <button type="button" className="nav-link-button" onClick={() => { setOpen(false); scrollToFeatures(); }}>
                            Paketlerimiz
                        </button>
                    </li>
                    <li>
                        <button type="button" className="nav-link-button" onClick={() => { setOpen(false); scrollToServices(); }}>
                            Hizmetler
                        </button>
                    </li>
                    <li>
                        <button type="button" className="nav-link-button" onClick={() => { setOpen(false); scrollToContact(); }}>
                            İletisim
                        </button>
                    </li>
                </ul>
                <li className="nav-contact">
                    <a
                        href="tel:+905013341032"
                        className="nav-phone"
                        onClick={() => setOpen(false)}
                    >
                        +90 501 334 10 32
                    </a>
                    <a
                        href="https://wa.me/905013341032"
                        className="nav-whatsapp"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => setOpen(false)}
                    >
                        <FaWhatsapp className="whatsapp-icon" />
                        <span className="whatsapp-label">WhatsApp</span>
                    </a>
                </li>
            </nav>
            <div className="under-contact">
                <li className="under-nav-contact">
                    <a
                        href="tel:+905013341032"
                        className="nav-phone"

                    >
                        +90 501 334 10 32
                    </a>
                    <a
                        href="https://wa.me/905358837510"
                        className="nav-whatsapp"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FaWhatsapp className="whatsapp-icon" />
                        <span className="whatsapp-label">WhatsApp</span>
                    </a>
                </li>
            </div>
        </header>
    );
}